import { isEmpty, isNil, isUndefined } from 'lodash';
import { MathArray } from 'mathjs';
import { NOT_APPLICABLE } from 'common/constants/general';
import { CellValue, ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { normalizeMathArray } from 'utilities';
import { Filter } from './types';

export const FILTER_ENABLED: Filter<ICell> = params => {
  const { _data: data } = params;

  const result = data
    .filter(cell => cell.enabled && Number.isFinite(Number(cell.value)) && !isUndefined(cell.value))
    .map(cell => cell.value);

  if (isEmpty(result)) {
    return [0];
  }

  return result;
};

export const FILTER_NULL: Filter = params => {
  const { _data: data } = params;

  const result = data.filter(
    value => !isNil(value) && value !== NOT_APPLICABLE && Number.isFinite(Number(value)) && value !== 0
  );

  if (isEmpty(result)) {
    return [0];
  }

  return result;
};

export const FILTER_VALID: Filter<ICell | CellValue> = params => {
  const { _data: data } = params;

  const normalizedData: CellValue[] = normalizeMathArray(data as MathArray);

  const result = normalizedData.map(value =>
    isNil(value) || value === NOT_APPLICABLE || !Number.isFinite(Number(value)) ? 0 : value
  );

  if (isEmpty(result)) {
    return [0];
  }

  return result;
};
